export default __webpack_public_path__ + "static/media/ARM_Logo_2017reverse.01ebea6e.png";